export const infiniteScroll = {
  isLoadingMore: false,

  mounted() {
    this.el.addEventListener("scroll", (_e) => {
      if (this.scrollLevel() > 90 && this.hasMore() && !this.isLoadingMore) {
        this.isLoadingMore = true
        this.pushEventTo(this.el, "load-more", {})
      }
    })

    // Check if content is too short to scroll on mount
    this.checkIfNeedsMoreContent()
  },

  updated() {
    this.isLoadingMore = false

    // Use requestAnimationFrame to ensure DOM is fully settled before checking
    // This prevents race conditions when items_per_page is small
    requestAnimationFrame(() => {
      this.checkIfNeedsMoreContent()
    })
  },

  checkIfNeedsMoreContent() {
    const hasHeight = this.el.clientHeight > 0

    // Only check if element has been rendered with actual height
    // If there's more content to load and the container isn't scrollable, load more
    if (
      hasHeight &&
      this.hasMore() &&
      !this.isScrollable() &&
      !this.isLoadingMore
    ) {
      this.isLoadingMore = true
      this.pushEventTo(this.el, "load-more", {})
    }
  },

  isScrollable() {
    // Check if content height exceeds container height (i.e., can scroll)
    return this.el.scrollHeight > this.el.clientHeight
  },

  hasMore() {
    return this.el.dataset.hasMore == ""
  },

  scrollLevel() {
    const scrollTop = this.el.scrollTop
    const scrollHeight = this.el.scrollHeight
    const clientHeight = this.el.clientHeight

    return (scrollTop / (scrollHeight - clientHeight)) * 100
  },
}
